<template>
    <section id="contact_us_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <h3 class="mt-4 mb-0 d-block d-lg-none">مقر الشركة</h3>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <h3 class="d-none d-lg-block">مقر الشركة</h3>

                        <p>
                            <img src="@/assets/images/contact_us/location_icon.webp" alt="Mail" class="contactImg ms-2">
                            المملكة العربية السعودية - الإمارات العربية المتحدة - مصر
                        </p>

                        <p>
                            <img src="@/assets/images/contact_us/address_icon.webp" alt="Mail" class="contactImg ms-2">
                            المملكة العربية السعودية، الرياض طريق عثمان بن عبدالله، الإزدهار، 7375، الرياض
                        </p>

                        <h5 class="mt-3">تواصل معنا عبر الهاتف أو البريد الإلكتروني</h5>

                        <p>
                            <img src="@/assets/images/contact_us/phone_icon.webp" alt="Contact" class="contactImg ms-2">
                            <span>9-6653-1577-796+</span>
                        </p>

                        <p>
                            <img src="@/assets/images/contact_us/mail_icon.webp" alt="Mail" class="contactImg ms-2">
                            <a href="mailto:info@Steamademy.com" class="text-reset">info@thaka.sa</a>
                        </p>

                        <h5 class="mt-3">آخر الأخبار</h5>

                        <p>ادخل بريدك الإلكتروني ليصلك كل جديد</p>

                        <!-- Email input -->
                        <div class="input-group mt-2 mb-3">
                            <input type="email" class="form-control" placeholder="البريد الإلكتروني" aria-label="Email"
                                aria-describedby="basic-addon1" />
                            <span class="input-group-text" id="basic-addon1">
                                <!-- <i class="fa-solid fa-paper-plane fa-rotate-270"></i> -->
                                <!-- <font-awesome-icon icon="fa-paper-plane" /> -->
                                <font-awesome-icon :icon="['fas', 'fa-paper-plane']" class="inputIco" />
                            </span>
                        </div>

                        <!-- Social Links -->
                        <div id="social" class="mb-3 mb-lg-0">
                            <a href="https://www.facebook.com/" class="me-4 text-reset">
                                <!-- <i class="fa-brands fa-facebook-f"></i> -->
                                <font-awesome-icon :icon="['fab', 'facebook-f']" />
                            </a>
                            <a href="https://twitter.com/" class="me-4 text-reset">
                                <!-- <i class="fa-brands fa-x-twitter"></i> -->
                                <font-awesome-icon :icon="['fab', 'x-twitter']" />
                            </a>
                            <a href="https://www.instagram.com/" class="me-4 text-reset">
                                <!-- <i class="fa-brands fa-instagram"></i> -->
                                <font-awesome-icon :icon="['fab', 'instagram']" />
                            </a>
                            <a href="https://www.linkedin.com/" class="me-4 text-reset">
                                <!-- <i class="fa-brands fa-linkedin-in"></i> -->
                                <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                            </a>
                        </div>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/contact_us/contact_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'ContactUs',
}
</script>

<style lang="scss" scoped>
#contact_us_content {

    height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
        height: auto;
    }

    @include breakpoints(small) {
        margin-top: 86px;
        height: auto;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
        height: auto;
    }

    .container {

        #first_row {

            h3 {
                font-family: 'FFShamelFamily-Bold';
                color: $Green;
                font-size: 18px;
                line-height: 180%;
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;
                }

                .contactImg {
                    width: 24px;
                    height: 24px;
                }

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $Green;
                }

                .input-group {

                    width: 80%;

                    // @include breakpoints(x-small) {
                    //     width: 80%;
                    // }

                    // @include breakpoints(small) {
                    //     width: 80%;
                    // }

                    // @include breakpoints(medium) {
                    //     width: 80%;
                    // }

                    input {
                        border: none;
                        border-radius: 0 4px 4px 0 !important;
                        caret-color: $Gry;
                    }

                    input:focus,
                    input:focus+span {
                        border: none;
                        box-shadow: none;
                    }

                    input::placeholder {
                        color: $Gry;
                        font-size: 14px;
                        // font-size: 14px;
                        font-weight: 400;
                    }

                    input:focus::placeholder {
                        color: transparent;
                    }

                    span {
                        border: none;
                        border-radius: 4px 0 0 4px !important;
                        background: $Linear-Blue;
                        color: $White;
                    }

                    .inputIco {
                        // CSS Vendor Prefixes
                        -webkit-transform: rotate(270deg);
                        -moz-transform: rotate(270deg);
                        -o-transform: rotate(270deg);
                        -ms-transform: rotate(270deg);
                        transform: rotate(270deg);
                    }

                }

                #social {
                    a {
                        svg {
                            color: $Green;
                        }

                        svg:hover {
                            color: $White;
                        }
                    }
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

    }

}
</style>